import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    paperBig: {
        backgroundColor: theme.palette.background.paper,
        borderColor: theme.palette.secondary.main,
        border: "solid 1px",
        borderRadius: 20,
        boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.4)",
        margin: 10
    },
    paperBigHighlighted: {
        backgroundColor: theme.palette.background.paper,
        borderColor: theme.palette.secondary.main,
        border: "solid 5px",
        borderRadius: 20,
        boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.4)",
        margin: 10
    },
    valueBig: {
        ...theme.typography.h3,
        color: theme.palette.text.primary,
        display: 'flex',
        justifyContent: "center"
    },
    headerBig: {
        ...theme.typography.subtitle2,
        color: theme.palette.text.secondary,
        display: 'flex',
        justifyContent: "right",
        paddingTop: 2,
        paddingRight: 10,
    },
    paperSmall: {
        backgroundColor: theme.palette.background.paper,
        borderColor: theme.palette.secondary.main,
        border: "solid 1px",
        borderRadius: 20,
        boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.4)",
        margin: 10
    },
    paperSmallHighlighted: {
        backgroundColor: theme.palette.background.paper,
        borderColor: theme.palette.secondary.main,
        border: "solid 5px",
        borderRadius: 20,
        boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.4)",
        margin: 10
    },
    headerSmall: {
        ...theme.typography.subtitle2,
        color: theme.palette.text.secondary,
        display: 'flex',
        justifyContent: "center"
    },
    valueSmall: {
        ...theme.typography.h5,
        color: theme.palette.text.primary,
        display: 'flex',
        justifyContent: "center"
    },
}));

export {useStyles};